module.exports = __webpack_public_path__ + "img/jenkin2.84985daf.svg";